module.exports = __webpack_public_path__ + "img/prepended-font-size.600a2fac.svg";